<template>
  <div>
    <h1 class="page-title">Overview</h1>
    <div v-if="loading || $apollo.subscriptions.websites_website.loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>
    <div v-else>
      <div v-if="!loading && crawlError">
        <b-alert show variant="danger">There was an error running your check, our engineers will investigate.
          <p></p>
        The credits have been refunded to your account, please try again later.

        </b-alert>
      </div>
    <div v-else-if="!loading && !website.pageCount" class="page-loading-container">
      <b-card title="Starting Check" >
        <a :href="website.url" target="_blank">{{website.url}}</a>
        <b-card-text>
          <b-progress :value="progress" :max="100" animated></b-progress>
        </b-card-text>

        <b-card-text>Results should start showing up within a few seconds</b-card-text>
      </b-card>
    </div>
    <div v-else>
      <b-row>
        <b-col xs="6" lg="7">
          <div class="table-responsive hide-scrollbars-large">
            <table class="" >
          <router-link :to="{ name: 'ExplorePageDetails', query: {url: homePage.path} }" title="Page Details" class="image-link">
          <div class="mr-lg d-flex align-items-center" style="position:relative;height:233px">
            <vue-load-image v-if="screenshots['chrome']">
              <img
                slot="image"
                width="380"
                :src="`${screenshots['chrome'].main.screenshot.url}?tr=w-380`"
                style="border-radius: 0.25rem; box-shadow: 0 0 40px #f0f3ff;"
              />
              <div
                slot="preloader"
                class="image-loading-container"
                style="width:380px;height:200px;box-shadow: 0 0 40px #f0f3ff;"
              >
                <div>
                  <b-spinner label="Loading..."></b-spinner><br />Loading..
                </div>
              </div>
              <div slot="error" class="screenshot-error">
                <p></p>
                <h4>Cannot Load Image.</h4>
                <p>
                  If this problem persists please let us know.
                </p>
                <i class="fa fa-warning"></i>
              </div>
            </vue-load-image>
            <img src="/iphone.png" width="122" height="233" style="" />
            <vue-load-image v-if="screenshots['galaxy_s6']">
              <img
                slot="image"
                :src="`${screenshots['galaxy_s6']['main'].screenshot.url}?tr=w-108`"
                width="108"
                style="position:absolute;left:387px;top:19px;border-radius:4px"
              />
              <div
                slot="preloader"
                class="image-loading-container"
                style="width:108px;height:188px;position:absolute;left:387px;top:20px;border-radius:4px"
              >
                <div><b-spinner label="Loading..."></b-spinner></div>

              </div>
              <div slot="error"  class="screenshot-error" style="width:108px;height:188px;position:absolute;left:387px;top:20px;border-radius:4px">
                <div>Cannot load screenshot<p> <i class="fa fa-warning"></i></p></div></div>
            </vue-load-image>

          </div>
          </router-link>
            </table>
          </div>&nbsp;

          <div>
            <Widget title="Updated Pages" :updating="!scanStatus.completed" style="padding-bottom:4px">
              <div class="pt-4" v-if="trends.heatMap && trends.heatMap.categories.length > 0" :key="dataLoaded.history">
                <b-alert style="margin-bottom:0" show variant="info" v-if="trends.heatMap.categories.length > 1">{{updatedPages}} Updated pages detected in previous {{trends.heatMap.categories.length}} audits.</b-alert>
                <b-alert style="margin-bottom:0" show variant="info" v-else>Run another test to identify all updated pages.</b-alert>
                <div >
                  <heat-graph dateFormat="MMM D" :hideYLabels="true" :hideXLabels="false" routeName="ChangesPage" :pad="0" :height="90" :options="trends.heatMap"></heat-graph>


                </div>
              </div>

            </Widget>
          </div>
        </b-col>
        <b-col xs="6" lg="5">
          <div class="pb-xlg">
            <Widget class=" mb-0 dashboard-title" :title="homePage.title | truncate(100)">
              <p>
                <a :href="homePage.url" target="_blank" v-b-tooltip.hover title="External Link">{{ homePage.url | truncate(60) }}</a>
              </p>
                <div v-if="scanStatus.completed">
                  <small class=" align-items-center">
                    Last Check: {{homePage.crawl_date | moment('from')}}<p></p>
                    <div  v-if="user.role === 'demo'">
                      <b-button href="https://app.pagewatch.dev/register" variant="success" size="sm">Sign Up To Run Another Audit</b-button>
                    </div>
                    <div v-else-if="(user.role === 'user' && !website.demo && website.max_crawl_pages > user.available_audits)">
                      <demo-notice :angleRight="false" alert="" button="Run Another Audit"></demo-notice>
                    </div>
                    <div  v-else-if="user.role === 'user' && !website.demo"><b-button size="sm"  @click="recheck" variant="info" >
                      Check Again</b-button>
                      <small v-if="activeSite.recurringSchedule">&nbsp;  Scheduled {{activeSite.recurringSchedule}}</small>
                    </div>
                  </small>
                </div>
              <div v-else>
                <b-alert show variant="secondary" class="mt-4" >
                  <b-spinner label="Loading..." style="width:16px;height:16px"></b-spinner>&nbsp; Audit in progress
                </b-alert>
              </div>
            </Widget>
          </div>
          <div>
            <Widget title="Latest Audit" :updating="!scanStatus.completed">
              <table class="table align-middle table-sm" >
                <thead></thead>
                <tbody>
                <tr>
                  <td  class="align-middle" width="90%"><i class="glyphicon glyphicon-indent-right audit-icon" style="top:-1px"></i> <router-link  :to="`${firstIssue}`">Layout Errors</router-link></td>

                  <td class="align-middle">
                    <b-badge variant="warning" :to="`${firstIssue}`" v-if="deviceIssuesCount>0">{{deviceIssuesCount}} Pages</b-badge>
                    <b-badge v-else variant="success">No Issues</b-badge>
                  </td>
                </tr>
                <tr>
                  <td  class="align-middle">
                    <i class="fi flaticon-network audit-icon"></i> <router-link :to="{'name': 'BrokenLinksPage'}">Broken Links</router-link></td>
                  <td class="align-middle">
                    <b-badge variant="warning" :to="{'name': 'BrokenLinksPage'}" v-if="stats.brokenLinksCount>0">{{stats.brokenLinksCount}} Broken Links</b-badge>
                    <b-badge v-else variant="success">No Issues</b-badge>
                  </td>
                </tr>
                <tr>
                  <td  class="align-middle"><i class="fi flaticon-network audit-icon"></i>  <router-link :to="{'name': 'BrokenResourcesPage'}">Broken Resources</router-link></td>
                  <td class="align-middle">
                    <b-badge variant="warning" :to="{'name': 'BrokenResourcesPage'}" v-if="stats.brokenResourcesCount>0">{{stats.brokenResourcesCount}} Issues</b-badge>
                    <b-badge v-else variant="success">No Issues</b-badge>
                  </td>
                </tr>
                <tr>
                  <td  class="align-middle"><i class="fa fa-rocket audit-icon"></i>  <router-link :to="{'name': 'SeoRedirectsPage'}">SEO Problems</router-link></td>
                  <td class="align-middle">
                    <b-badge variant="warning" :to="{'name': 'SeoRedirectsPage'}" v-if="stats.internalRedirectsCount>0">{{stats.internalRedirectsCount}} Issues</b-badge>
                    <b-badge v-else variant="success">No Issues</b-badge>
                  </td>
                </tr>
                <tr>
                  <td  class="align-middle"><i class="fa fa-warning audit-icon"></i>  <router-link :to="{'name': 'JavascriptPage'}">Javascript Errors</router-link></td>
                  <td class="align-middle">
                    <b-badge variant="warning" :to="{'name': 'JavascriptPage'}" v-if="stats.errorLogsCount>0">{{stats.errorLogsCount}} Issues</b-badge>
                    <b-badge v-else variant="success">No Issues</b-badge>
                  </td>
                </tr>
                <tr>
                  <td  class="align-middle"><i class="fa fa-language audit-icon"></i>  <router-link :to="{'name': 'SpellingPage'}">Spelling Mistakes</router-link></td>
                  <td class="align-middle">
                    <b-badge variant="warning" :to="{'name': 'SpellingPage'}" v-if="stats.spellingIssuesCount>0">{{stats.spellingIssuesCount}} Issues</b-badge>
                    <b-badge v-else variant="success">No Issues</b-badge>
                  </td>
                </tr>
                </tbody>
              </table>
            </Widget>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <Widget title="Median Performance Across All Pages" :updating="!scanStatus.completed">
            <div class="table-responsive hide-scrollbars-large">
              <div v-if="trends.performance && trends.performance.categories.length > 0" :key="dataLoaded.trends">
                <trend-graph :clickable="true" routeName="PerformancePerformancePage" :height="180" units="ms" :options="trends.performance"></trend-graph>
              </div>
              <div v-else>
                <b-alert show variant="primary" class="mt-4"><b-spinner style="height: 18px;width: 18px;" label="Loading..." ></b-spinner> Generating Performance Data</b-alert>
              </div>
            </div>
          </Widget>
        </b-col>
      </b-row>
    </div>
  </div>
  </div>
</template>

<script>
import Widget from "@/components/Widget/Widget";
import DemoNotice from "@/components/DemoNotice/DemoNotice";
import axios from "axios";
import { ApolloClient } from "apollo-client";
import gql from "graphql-tag";
import { mapState } from "vuex";
import VueLoadImage from "vue-load-image";
import HeatGraph from "@/components/TrendGraph/HeatGraph";
import TrendGraph from "@/components/TrendGraph/TrendGraph";


export default {
  name: "Dashboard",

  components: { Widget, "vue-load-image": VueLoadImage, DemoNotice, HeatGraph, TrendGraph },
  data() {
    return {
      trends:{
        history:[],
        heatMap:{
          series:[
            {name: 'Changed Pages', data:[]},
          ],
          categories: []
        }
      },
      crawlError: false,
      loading: true,
      dataLoaded: {
        trends: 0,
        history: 0,
        websites_website: 0,
      },
      progress: 1,
      toastOptions: {
        theme: 'dark',
        position: 'bottomLeft',
      },
      stats: {},
      historyIds: [],
      latestStats: {},
      completedAt: '',
      deviceIssuesCount: 0,
      firstIssue: '',
      website: {pageCount: 0},
      homePage: {},
      screenshots: {
        main: ""
      }
    };
  },
  apollo: {
    $subscribe: {
      trends: {
        query() {
          return gql`subscription {
                    trends:websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
                      websites_crawls(limit: 30) {
                        id
                        started_at
                        websites_trends(where: {name: {_eq: "performance_metrics"}}) {
                          id
                          name
                          data_summary
                        }
                      }
                  }
            }`
        },
        skip () {
          return !this.activeSite.id || (this.dataLoaded.trends && this.scanStatus.completed)
        },
        result (data) {
          this.trends.performance = {
              series:[
                {
                  name: 'First Contentful Paint',
                  data:[],
                },
                {
                  name: 'Interactive',
                  data:[],
                },
                {
                  name: 'Total Blocking Time',
                  data:[],
                },
                {
                  name: 'Speed Index',
                  data:[],
                },
              ],
              categories: [],
              categoryParams: [],
            };

          for (let i=data.data.trends[0].websites_crawls.length-1; i>=0; i--){
            let entry = data.data.trends[0].websites_crawls[i];
            if (!(entry.websites_trends && entry.websites_trends[0])){
              continue
            }
            let summary = entry.websites_trends[0].data_summary || {}
            this.trends.performance.series[0].data.push((summary.first_contentful_paint || {}).median || 0);
            this.trends.performance.series[1].data.push((summary.interactive || {}).median || 0);
            this.trends.performance.series[2].data.push((summary.total_blocking_time || {}).median || 0);
            this.trends.performance.series[3].data.push((summary.speed_index || {}).median || 0);
            this.trends.performance.categories.push(entry.started_at)
            this.trends.performance.categoryParams.push(entry.id)
          }
          this.$set(this.trends, "performance", this.trends.performance);
          this.dataLoaded.trends += 1;
        },
      },
      history: {
        query() {
          return gql`subscription {
                    history:websites_crawl(where: {website_id: {_eq: ${this.activeSite.id}}}, order_by:{completed_at: desc}, limit: 30){
                          id
                          parent_crawl_id
                          started_at
                          websites_diffs{
                            id
                            type
                            ratio
                            websites_crawledpage{
                                id
                                level
                                url
                                path
                              }
                            websites_devicerender{
                                id
                                device_id
                            }
                          }
                    }
        }`
        },
        skip () {
          return !(this.activeSite) || (this.dataLoaded.history && this.scanStatus.completed)
        },
        result(data){
          this.trends.heatMap = {
            series: [
              {name: 'Changed Pages', data:[], params: []},
            ],
            categories:[],
            categoryParams:[]
          };
          for (let i=data.data.history.length-1; i>=0; i--){
            let entry = data.data.history[i];
            this.trends.heatMap.series[0].data.push(entry.websites_diffs.filter((v) => {
              return (v.websites_devicerender && v.websites_devicerender.device_id === 'chrome' && v.type === 17)
            }).length);
            this.trends.heatMap.categoryParams.push(entry.id);
            this.trends.heatMap.categories.push(new Date(entry.started_at).getTime());
          }
          this.$set(this.trends, "heatMap", this.trends.heatMap);
          this.dataLoaded.history += 1;
        }
      },

      websites_website: {
        query() {
          return gql`subscription {
              websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
              id
              uuid
              url
              latest_stats
              recurring_schedule
              demo
              max_crawl_pages
                websites_crawledpages(limit: 1, where: {ready: {_eq: true}, is_latest: {_eq: true}, level: {_eq: 0}}) {
                  id
                  level
                  url
                  path
                  title
                  crawl_date
                  websites_devicerenders{
                    device_id
                    screenshots
                  }
                }

                websites_crawledpages_aggregate(where: {ready: {_eq: true}, is_latest: {_eq: true}, status: {_lt: 300}}){
                  aggregate {
                    count
                  }
                }
                websites_links_aggregate(where: {active: {_eq: true}}){
                  aggregate{
                    count
                  }
                }
                broken_links:websites_links_aggregate(where: {active: {_eq: true}, is_broken: {_eq: true}}){
                  aggregate{
                    count
                  }
                }
                internal_redirects:websites_links_aggregate(where: {active: {_eq: true}, is_broken: {_eq: false}, internal_redirect: {_eq: true}}){
                  aggregate{
                    count
                  }
                }
                websites_consolelogs_aggregate(where: {active: {_eq: true}}){
                  aggregate{
                    count
                  }
                }
                websites_vulnerabilities_aggregate(where: {active: {_eq: true}, severity: {_eq: "High"}}){
                  aggregate{
                    count
                  }
                }
                error_logs:websites_consolelogs_aggregate(where: {active: {_eq: true}, type: {_eq: "error"}}){
                  aggregate{
                    count
                  }
                }
                websites_spellingerrors_aggregate(where: {active: {_eq: true}}) {
                  aggregate {
                    count
                  }
                }
                broken_images:websites_brokenresources_aggregate(where: {active: {_eq: true}, resource_type: {_in: ["image"]}}){
                  aggregate{
                    count
                  }
                }
                broken_resources:websites_brokenresources_aggregate(where: {active: {_eq: true}, resource_type: {_in: ["js", "other"]}}){
                  aggregate{
                    count
                  }
                }

            }

          }`;
        },
        skip() {
          return !this.activeSite.id || (this.dataLoaded.websites_website && this.scanStatus.completed)
        },
        result(data) {
          this.crawlError = false;
          if (data.data.websites_website && data.data.websites_website.length) {
            this.website = data.data.websites_website[0];
            this.website.pageCount =
                    data.data.websites_website[0].websites_crawledpages_aggregate.aggregate.count;
            let website = data.data.websites_website[0];
            this.homePage = data.data.websites_website[0].websites_crawledpages[0];
            if (this.homePage) {
              this.latestStats = website.latest_stats;
              if (this.latestStats.layout_issues) {
                let issues = Object.entries(this.latestStats.layout_issues.pages).filter(([i, v]) => {
                  return v > 0
                });
                this.deviceIssuesCount = this.latestStats.layout_issues.total;
                this.firstIssue = issues[0] && issues[0][0] || 'ipad';
                this.firstIssue = `/${this.$route.params.token}/layout/issues/${this.firstIssue}`
              }

              this.crawlError = this.scanStatus.site.status === 'error';
              this.screenshots = {};
              for (let s of this.homePage.websites_devicerenders) {
                this.screenshots[s.device_id] = s.screenshots;
              }
              this.stats = {
                pageCount: website.websites_crawledpages_aggregate.aggregate.count,
                linksCount: website.websites_links_aggregate.aggregate.count,
                brokenLinksCount: website.broken_links.aggregate.count,
                internalRedirectsCount: website.internal_redirects.aggregate.count,
                consoleLogsCount: website.websites_consolelogs_aggregate.aggregate.count,
                vulnerabilitiesCount: website.websites_vulnerabilities_aggregate.aggregate.count,
                errorLogsCount: website.error_logs.aggregate.count,
                spellingIssuesCount: website.websites_spellingerrors_aggregate.aggregate.count,
                brokenImagesCount: website.broken_images.aggregate.count,
                brokenResourcesCount: website.broken_resources.aggregate.count,
              };
            }

            if (this.scanStatus.completed && !this.website.pageCount && this.scanStatus.site.errors && this.scanStatus.site.errors.length > 0){
              this.crawlError = true;
            }
          }
          if (this.website.pageCount === 0 && this.progress === 1){
            this.startProgressTimer(2);
          }
          this.loading = false;
          this.dataLoaded.websites_website += 1;
        }
      }
    }
  },
  methods: {
    doLogout() {
      ApolloClient.cache.data.clear();
    },
    startProgressTimer(progress){
      this.progress = Math.min(99, progress);
      if (this.progress <= 99 && !this.website.pageCount) {
        setTimeout(() => {
          this.startProgressTimer(progress + 1)
        }, 800)
      }
    },
    recheck(){
      const h = this.$createElement;
      let requiredCredits = this.website.max_crawl_pages;
      const titleVNode = h('div', {domProps: {innerHTML: `This will run another check immediately on up to <b>${requiredCredits}</b> pages.`}});
      this.$bvModal.msgBoxConfirm([titleVNode], {
        title: 'Check Again',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Continue',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
              .then(ok => {
                if (ok) {
                  axios
                          .put(`websites/recheck/${this.website.uuid}`, {scope: 'site'})
                          .then(
                                  response => {
                                    this.$toast.show(`started`, 'Website Check', this.toastOptions);
                                    return true;
                                  },
                                  response => {
                                    this.$toast.show('Unable to start check', 'Error', this.toastOptions);
                                    return false;
                                  }
                          )
                }
              })

    }
  },
  computed: {
    ...mapState({ activeSite: "activeSite", user: "user", scanStatus: "scanStatus" }),
    updatedPages(){
      if (this.trends.heatMap){
        return (this.trends.heatMap.series[0].data).reduce((a, b) => a + b, 0)
      }
      return 0;
    }
  },
  watch: {
    activeSite(){
      this.dataLoaded = {
        trends: 0,
        history: 0,
        websites_website: 0,
      };
  }
  },
  mounted() {
    this.$root.$on('scan_completed',  () => {
      // if (this.$apollo.queries.history) {
      //   console.log('scan refresh1')
        // this.$apollo.queries.history.refetch();
      // }
    });
  },
  created(){
    this.firstIssue = `/${this.$route.params.token}/layout/issues/ipad`;
    this.$root.$on('scan_completed',  () => {
      // if (this.$apollo.queries.history) {
        // this.$apollo.queries.history.refetch();
      // }
    });

  }
};
</script>

<style src="./Dashboard.scss" lang="scss"  />
